import { Injectable } from "@angular/core";
import { HttpService } from "app/js/src/infrastructure/http/http";
import {
  IEmojiPickerProvider,
  EmojiPickerPayload,
} from "app/js/src/domain/clipping-studio/i-emoji-picker-provider";

/** API response (PascalCase from backend; payload optional in camelCase for compatibility). */
interface EmojiPickerApiItem {
  Id?: number;
  TenantId?: number | null;
  Payload?: string;
  payload?: string;
}

const DEFAULT_PAYLOAD: EmojiPickerPayload = { list: [], tags: {} };

@Injectable()
export class ClippingStudioEmojiPickerHttpService extends IEmojiPickerProvider {
  private readonly url = "clipping-studio/emoji-picker";

  constructor(private readonly httpService: HttpService) {
    super();
  }

  async getEmojiPicker(): Promise<EmojiPickerPayload> {
    const raw = await this.httpService.get(this.url);
    if (raw == null) return DEFAULT_PAYLOAD;
    const item = raw as EmojiPickerApiItem;
    const payloadStr = item.Payload ?? item.payload;
    if (!payloadStr || typeof payloadStr !== "string") return DEFAULT_PAYLOAD;
    try {
      const parsed = JSON.parse(payloadStr) as unknown;
      if (parsed && typeof parsed === "object" && "list" in parsed) {
        const obj = parsed as Record<string, unknown>;
        const list = Array.isArray(obj.list) ? (obj.list as string[]) : [];
        const rawTags = obj.tags;
        const tags =
          rawTags != null && typeof rawTags === "object" && !Array.isArray(rawTags)
            ? (rawTags as Record<string, string[]>)
            : {};
        return { list, tags };
      }
    } catch {
      /* ignore parse error */
    }
    return DEFAULT_PAYLOAD;
  }
}
